import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    marginRight: '0.5rem'
  }
}))

export default useStyles
